<template>
  <v-container>
    <v-app-bar app color="primary" dark dense>
      <v-app-bar-nav-icon @click.stop="menu()"></v-app-bar-nav-icon>
      <div class="appName">
        <p>{{ $store.getters.getAppName }}</p>
      </div>
      <v-spacer />
      <img
        src="@/assets/logo.png"
        width="70"
        alt=""
        @click="window.location.reload(0)"
      />
      <v-spacer />
      <p class="hour">
        <span class="bd">
          <v-icon small>mdi-calendar-range</v-icon>
          <span class="mr-2">{{ date }}</span>
        </span>
        <span class="bd">
          <v-icon small>mdi-clock-outline</v-icon>
          <span class="mr-2">{{ time }}</span>
        </span>
      </p>
      <v-btn class="ml-2" style="font-size: 1rem" text @click="logOut"
        >Sair</v-btn
      >
      <v-progress-linear
        :active="$store.getters.getLoader"
        :indeterminate="$store.getters.getLoader"
        absolute
        bottom
        color="secondary"
      ></v-progress-linear>
    </v-app-bar>
    <Menu />
  </v-container>
</template>

<script>
import Menu from "./Menu.vue";
export default {
  components: {
    Menu,
  },
  data: () => ({
    date: "",
    time: "",
  }),
  created() {
    this.initilizeTime();
  },  
  methods: {
    menu() {
      this.$store.dispatch("activeMenu", !this.$store.getters.getMenuState);
    },
    logOut() {
      let c = confirm("Deseja sair do sistema?");
      if (c) {
        localStorage.removeItem("userData");
        localStorage.removeItem("vuex");
        localStorage.removeItem("token");
        this.$router.replace("/login");
      }
    },
    initilizeTime() {
      this.date = new Date().toLocaleDateString("pt-br");
      setInterval(() => {
        let time = " " + new Date().toLocaleTimeString("pt-br");
        this.time = time;
      }, 1000);
    },
  },
};
</script>
<style scoped>
.hour {
  margin: 10px 0;
  color: #ffffff;
  font-size: 1.1rem;
}
.bd {
  border-right: 1px solid #ddd;
  margin: 0 5px;
}
.appName {
  display: flex;
  align-items: center;
}

.appName p {
  position: relative;
  top: 10px;
  left: 5px;
}
</style>

// Este e o header da aplicacao. Possui o metodo menu onde e passado a uma variavel global (VUEX) para gerenciar a abertura e fechamento do menu.

esta funcao e uma action que e responsavel por atualizar o menu com o seu valor invertido.
this.$store.dispatch("activeMenu", !this.$store.getters.getMenuState);

foi importado um componente chamado Menu.